class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle?.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle?.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle?.addEventListener(
      "toggle",
      this.onToggle.bind(this)
    );
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.contains(document.activeElement)) return;
      const megaMenuPanel = document.getElementById("mega-menu-panel");
      if (megaMenuPanel && megaMenuPanel.contains(document.activeElement))
        return;
      this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.closeTimeout = null;
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.addEventListener(
        "mouseenter",
        this.onMouseEnter.bind(this)
      );
      this.mainDetailsToggle.addEventListener(
        "mouseleave",
        this.onMouseLeave.bind(this)
      );
    }
    // Listen for mouseenter on the mega-menu panel to cancel close timeout
    this.setupPanelListener();
  }

  setupPanelListener() {
    const megaMenuPanel = document.getElementById("mega-menu-panel");
    if (
      megaMenuPanel &&
      !megaMenuPanel.hasAttribute("data-header-menu-listener")
    ) {
      megaMenuPanel.setAttribute("data-header-menu-listener", "true");
      megaMenuPanel.addEventListener("mouseenter", () => {
        // Cancel close timeout on all HeaderMenu instances
        document.querySelectorAll("header-menu").forEach((menu) => {
          if (menu.closeTimeout) {
            clearTimeout(menu.closeTimeout);
            menu.closeTimeout = null;
          }
        });
      });
      megaMenuPanel.addEventListener("mouseleave", (e) => {
        // Close menu when leaving the panel (unless going back to header area)
        const headerWrapper = document.querySelector(".header-wrapper");
        if (
          e.relatedTarget &&
          headerWrapper &&
          headerWrapper.contains(e.relatedTarget)
        )
          return;
        document.querySelectorAll("header-menu").forEach((menu) => {
          if (
            menu.mainDetailsToggle &&
            menu.mainDetailsToggle.hasAttribute("open")
          ) {
            menu.closeTimeout = setTimeout(() => {
              menu.close();
              menu.closeTimeout = null;
            }, 200);
          }
        });
      });
    }
  }

  onMouseEnter() {
    if (!window.matchMedia("(min-width: 1000px)").matches) return;
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    document.querySelectorAll('details-modal').forEach((modal) => {
      if (modal.isOpen()) modal.close(false);
    });

    this.mainDetailsToggle.setAttribute("open", "");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", "true");
    // Then close all other HeaderMenu instances
    // Since this menu is now open, the close handlers will skip content removal
    document.querySelectorAll("header-menu").forEach((menu) => {
      if (menu !== this) {
        if (menu.closeTimeout) {
          clearTimeout(menu.closeTimeout);
          menu.closeTimeout = null;
        }
        if (
          menu.mainDetailsToggle &&
          menu.mainDetailsToggle.hasAttribute("open")
        ) {
          menu.close();
        }
      }
    });
  }

  onMouseLeave(e) {
    if (!window.matchMedia("(min-width: 1000px)").matches) return;
    // Check if mouse is moving to the details element itself
    if (e.relatedTarget && this.mainDetailsToggle.contains(e.relatedTarget))
      return;
    // Check if mouse is moving to the mega-menu panel (content is moved there when open)
    const megaMenuPanel = document.getElementById("mega-menu-panel");
    if (
      e.relatedTarget &&
      megaMenuPanel &&
      megaMenuPanel.contains(e.relatedTarget)
    )
      return;
    // Check if mouse is moving to another header-menu item (will be handled by that menu's onMouseEnter)
    if (e.relatedTarget && e.relatedTarget.closest("header-menu")) return;
    this.closeTimeout = setTimeout(() => {
      this.close();
      this.closeTimeout = null;
    }, 200);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
